import PropTypes from 'prop-types'
import { DownloadOutlined } from '@ant-design/icons'
import { Button, Tooltip, message } from 'antd'

import { useDispatch } from 'react-redux'
import { createUseStyles } from 'react-jss'
import { initDownload } from '../../redux/slices/downloads'
import useQueryParams from '../../hooks/useQueryParams'
import api from '../../api'

// A disabled button never fires the mouse events a Tooltip triggers on, so the
// hover has to be taken by a wrapping span instead, with the button itself
// dropped out of hit testing. It stays `disabled` so it is genuinely unclickable.
const useStyles = createUseStyles({
  disabledTrigger: {
    display: 'inline-block',
    cursor: 'not-allowed',
  },
  disabledButton: {
    pointerEvents: 'none',
  },
})

export default function BatchDownloadButton({ cycleId, pdfPending = false }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const [queryParams] = useQueryParams({})
  const { page, perPage, cycleId: cycle, ...searchParams } = queryParams

  const downloadBatch = async () => {
    try {
      await api.downloads.create(cycleId, searchParams)

      dispatch(initDownload(cycleId))
    } catch (err) {
      message.error(`Something went wrong: ${err.message}`)
    }
  }

  const getButtonTitle = () => {
    const { ...filters } = searchParams

    // FIXME: These query params shouldn't be added if they have the default value
    if (filters.query === '') delete filters.query
    if (filters.signed === 'all') delete filters.signed

    if (Object.keys(filters).length > 0) {
      return 'Download Filtered Reports'
    }

    return 'Download All Reports'
  }

  const button = (
    <Button
      icon={<DownloadOutlined />}
      onClick={downloadBatch}
      disabled={pdfPending}
      className={pdfPending ? classes.disabledButton : undefined}
    >
      {getButtonTitle()}
    </Button>
  )

  if (!pdfPending) return button

  return (
    <Tooltip title="The download is unavailable until the signed PDFs finish generating.">
      <span className={classes.disabledTrigger}>{button}</span>
    </Tooltip>
  )
}

BatchDownloadButton.propTypes = {
  cycleId: PropTypes.string.isRequired,
  pdfPending: PropTypes.bool,
}
